import React, { Component } from 'react';

import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

class DonationPrompt extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };
    }
    
    render() {
        const message = this.state.message ? (<Alert variant="danger">{this.state.message}</Alert>) : undefined;

        return (
            <Modal show={this.props.show} onHide={() => this.handleClose(false)} size="lg">
                <Modal.Header closeButton>
                <Modal.Title>Can you support WisCon?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {message}
                    <p>WisCon relies on donations to keep providing the great experiences you've
                      come to know and love. Even a dollar helps!</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="link" onClick={() => this.handleClose(false)}>
                        Not Now
                    </Button>
                    <Button variant="primary" onClick={() => this.handleClose(true)}>
                        Yes, I can support WisCon!
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    handleClose(donate) {
        if (this.props.onClose) {
            this.props.onClose(donate);
        }
    }
}

export default DonationPrompt;